import React, {FC} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import { Largeprocessors } from '../../../components/Grossharvestofproducts/Largeprocessors';

const LargeprocessorsPage: FC = () => {
    const {t} = useTranslation();

    return (
        <>
            <Helmet>
                <title>Крупные переработчики</title>
            </Helmet>
            <Largeprocessors/>
        
        </>
    );
};

export default LargeprocessorsPage
